export const checkIsServiceNonTopUp = (showVouchersForm: boolean, payee: { params?: Array<{ name: string }> }) => {
  const isNonTopUpService =
    showVouchersForm && Boolean(payee.params?.find((param) => param.name === 'id1' || param.name === 'email'))

  return isNonTopUpService
}
